import {PaginationSummaryFormatter} from "peggirkit";
import {IntlShape} from "react-intl";

export const paginationSummaryFormatter = (intl: IntlShape): PaginationSummaryFormatter =>
    ((from: number, to: number, total: number) => intl.formatMessage({id: "paginationSummary"}, {from, to, total}));
